var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"dashboard",staticStyle:{"background-color":"#F0F0F0"},attrs:{"title":"Statistik"}},[_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			{
				label: 'Medarbejder',
				name: 'name',
				weight: '10fr'
			},
			{
				label: 'Opgaver',
				data: ' ',
				align: 'right'
			},
			{
				label: '9',
				name: ['_embedded', 'status', 'open_tasks'],
				align: 'right',
				weight: '100px'
			},
			{
				label: 'Omsætning',
				data: ' ',
				align: 'right',
				weight: '200px'
			},
			{
				label: '35.900,00',
				name: ['_embedded', 'status', 'open_value'],
				align: 'right',
				filter: 'number',
				weight: '200px'
			}
		],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }